import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from "recharts";
import React from "react";
import { formatFinance } from "../../../../utils/formatters";

export const TakeoutStats = ({ data, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TakeoutDiningIcon sx={{ mr: 1, color: "warning.main" }} />
        <Typography variant="h6">Retirada</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Faturamento
          </Typography>
          <Typography variant="h5">{formatFinance(data.totalSales)}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Ticket Médio
          </Typography>
          <Typography variant="h5">
            {formatFinance(data.averageOrder)}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Pedidos
          </Typography>
          <Typography variant="h5">
            {data.orderCount.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            vs. Período Anterior
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              sx={{
                color: data.percentChange >= 0 ? "success.main" : "error.main",
              }}
            >
              {data.percentChange.toFixed(1)}%
            </Typography>
            {data.percentChange >= 0 ? (
              <TrendingUpIcon sx={{ ml: 0.5, color: "success.main" }} />
            ) : (
              <TrendingDownIcon sx={{ ml: 0.5, color: "error.main" }} />
            )}
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Por Dia da Semana
      </Typography>

      <Box sx={{ height: 180 }}>
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart
            cx="50%"
            cy="50%"
            outerRadius={60}
            data={data.timePerformance}
          >
            <PolarGrid />
            <PolarAngleAxis dataKey="subject" tick={{ fontSize: 10 }} />
            <PolarRadiusAxis domain={[0, 100]} />
            <Radar
              name="Performance"
              dataKey="value"
              stroke="#FFBB28"
              fill="#FFBB28"
              fillOpacity={0.6}
            />
          </RadarChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};
